import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipGroupAnchor } from '@/components/shared/tooltip/TooltipGroup';
import Badge from '@/storybook/components/Badge/Badge';
import styles from './BetaBadge.module.css';

export interface BetaBadgeProps {
  'data-testid'?: string;
}

const BetaBadge: FC<BetaBadgeProps> = ({ 'data-testid': dataTestId }) => {
  const { t } = useTranslation();

  return (
    <TooltipGroupAnchor
      value={t('components.aiChatDrawer.header.betaTooltip')}
      place="top"
      className={styles.betaTooltip}
      forceDisplayTooltip
    >
      <span className={styles.betaBadgeAnchor} data-testid={dataTestId}>
        <Badge className={styles.betaBadge} variant="light" color="grey" size="S">
          {t('components.aiChatDrawer.header.betaBadge')}
        </Badge>
      </span>
    </TooltipGroupAnchor>
  );
};

export default BetaBadge;
